import { useQuery, QueryClient } from '@tanstack/vue-query';
import { useStoreCompat } from '@/composables/useStoreCompat'
import { useRest } from '@/composables/useRest'; 

const queryClient = new QueryClient();

export function useActuations() {
  const store = useStoreCompat();
  const rest = useRest();

  const getFirstPageFromActuations = async () => {
    await store.dispatch("sumarioList/updateOffset", 0);
    await store.dispatch("sumarioList/get");
    return store.state.sumarioList.denunciations;
  };

  const getAPageFromActuations = async (numberPage = 1) => {
    const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/sumario`;
    const result = await rest.get({
      url,
      params: {
        limit: 8,
        offset: 8 * (numberPage - 1),
        getTotal: false
      }
    });
    return result.data.data;
  };

  const getActuationsForTanstack = () => {
    const { data } = useQuery(
      ['actuations', 1],
      getFirstPageFromActuations,
      {
        staleTime: 300000,
        cacheTime: 300000,
        refetchOnWindowFocus: false
      }
    );
    queryClient.setQueryData(['actuations', 1], data);
    return data;
  };

  const getActuationsForTanstackByPage = async (numberPage = 1) => {
    const response = await queryClient.fetchQuery({
      queryKey: ['actuations', numberPage],
      queryFn: () => getAPageFromActuations(numberPage),
      staleTime: 300000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
    });
    queryClient.setQueryData(['actuations', numberPage], response);
    return response;
  };

  const getActuationsCachedByPage = async (numberPage = 1) => {
    return queryClient.getQueryData(['actuations', numberPage]);
  };

  const saveActuationInCache = async (id, value) => {
    await saveGenericDataInCache('actuation ' + id, value);
  };

  const getActuationFromCache = async (id) => {
    return getGenericDataFromCache('actuation ' + id);
  };

  const deleteActuationFromCached = async (id) => {
    await queryClient.removeQueries(['actuation ' + id]);
  };

  const saveGenericDataInCache = async (cacheName, value, time = 300000) => {
    queryClient.setQueryDefaults([cacheName], {
      staleTime: time,
      cacheTime: time,
    });
    queryClient.setQueryData([cacheName], { ...value });
  };

  const getGenericDataFromCache = async (cacheName) => {
    return queryClient.getQueryData([cacheName]);
  };

  const deleteGenericDataFromCached = async (cacheName) => {
    await queryClient.removeQueries([cacheName]);
  };

  return {
    getFirstPageFromActuations,
    getAPageFromActuations,
    getActuationsForTanstack,
    getActuationsForTanstackByPage,
    getActuationsCachedByPage,
    saveActuationInCache,
    getActuationFromCache,
    deleteActuationFromCached,
    saveGenericDataInCache,
    getGenericDataFromCache,
    deleteGenericDataFromCached
  };
}
